import { defineScreen } from "@vjal/screen-kit";
import { ProductRouteScreenAdapter } from "../pages/product-route-context";

/** ScreenModule IR authority — Component is the shared product route adapter. */

export const loginScreenModule = defineScreen({
  app: "coaching",
  screen_id: "login",
  path: "/login",
  heading: { text: "Sign in", level: 1 },
  roles: {
    "super_admin": "allow",
    "admin": "allow",
    "coach": "allow",
    "company_admin": "allow",
    "participant": "allow",
    "cohort_lead": "allow"
  },
  states: ["ready"],
  actions: [
    { id: "request-otp", kind: "primary", driver: "auth.requestOtp" },
    { id: "verify-otp", kind: "primary", driver: "auth.verifyOtp" },
    { id: "wrong-otp", kind: "danger", driver: "auth.wrongOtp" },
    { id: "session-restore", kind: "secondary", driver: "auth.sessionRestore" },
    { id: "logout", kind: "primary", driver: "auth.logout" }
  ],
  recipe: "Auth-1",
  data: { seedNeeds: ["auth-otp-disposable"] },
  authority: { source_ref: "apps/coaching-dashboard/src/screens/login.tsx" },
  Component: ProductRouteScreenAdapter,
});

export default loginScreenModule;
